import script from "./SelectorSimpler.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectorSimpler.vue?vue&type=script&setup=true&lang=ts"

import "./SelectorSimpler.vue?vue&type=style&index=0&id=c5292f2e&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5292f2e"]])

export default __exports__